import AnchorsGroupPic from '../../assets/GuestHome/about-anchors.jpg';
import BikiniReportPic from '../../assets/GuestHome/bikini-report.jpg';
import FanzonePic from '../../assets/GuestHome/NNL-Fanzone.jpg';
import NNL_LOGO from '../../assets/NakedNewsLive/NNL_283x140.png';
import CALENDAR_PIC_1 from '../../assets/2023-calendar-promo/Calendar-1.jpeg';


export const CAROUSEL_CONTENT = {
  'MEET_OUR_ANCHORS': {
    'heading1': 'Introducing the',
    'heading2': 'Naked News Hosts!',
    'content': 'The Naked News cast is made up of a diverse group of gorgeous women! They\'re all confident and secure and love showing off their personalities and their bodies. From Naked News to topless news, to their personal lives, once you\'ve experienced all they have to offer, the naked news ladies will have you hooked.',
    'image': AnchorsGroupPic,
    'target': '_self',
    'url': '/account/purchase',
    'rel': '',
  },
  'FANZONE': {
    'heading1': 'Naked News Live',
    'heading2': null,
    'content': 'Discover the intimate side of the world\'s most daring Stars on NakedNewsLive! Come and introduce yourself, and chat live with these provocative personalities who will perform multiple nude shows every week! Access all past naked news videos shows now, while you wait for the next one!',
    'image': FanzonePic,
    'url': '/live?showPaymentPopUp=1',
    'target': '_self',
    'logo': NNL_LOGO,
    'rel': '',
  },
  'BIKINI_REPORT': {
    'heading1': 'The Bikini Report:',
    'heading2': null,
    'content': 'Follow Naked News TV on TikTok and Instagram reels! @thebikinireport is where our stunning cast of the Naked News girls and guests present current events! Dressed in barely there outfits, you\'ll be hard pressed to absorb what they\'re saying the 1st time you watch. It\'ll quickly become your #1 source for news on Social Media!',
    'image': BikiniReportPic,
    'target': '_blank',
    'url': 'https://www.tiktok.com/@thebikinireport',
    'rel': 'noopener noreferrer nofollow',
  },
  'ADS_SECTION': {
    'heading1': 'It\'s the hottest',
    'heading2': 'Calendar for 2025!',
    'content': 'The 2025 Naked News “Pin Up” calendar has arrived! Each month is a daring fusion of art and allure, showcasing the timeless beauty and seductive charm of the Naked News cast. \nADDED BONUS\n With each Calendar purchase, you will get 1 free month of your favorite reporters Fan Zone. This is your way of connecting with them on a more personal and intimate level. PERSONALIZE YOUR CALENDAR! Get your calendar personalized with an autographed, signed copy from your favorite Naked News reporter',
    'image': CALENDAR_PIC_1,
    'target': '_blank',
    'url': 'https://shop.nakednews.com/index.php/product/2025-naked-news-calendar-12-x-12?utm_source=HOME_SLIDER',
    'rel': 'noopener noreferrer nofollow',
  },
};

export const mainCarouselContent = {
  'callToAction': 'It\'s time for you to join our groundbreaking program, Naked News! Forget about conventional shows and immerse yourself in a world full of excitement and Naked News models! Our naked anchors will leave you breathless and  guarantee you an experience that you won\'t soon forget. Become a member of Naked News today and start enjoying the news like never before. Our variety of mainstream and adult themed features will have you hooked and coming back for a daily dose of nude news. So what are you waiting for, come and join the party right now at NakedNews.com!',
  'main': 'The sexiest naked reporters around the world cover news, sports, pop culture and much more. And while they strip down the facts, they strip down themselves. Enjoy 6 new naked shows a week, plus exclusive access to our archives containing thousands of segments including our popular naked news auditions. Sign up now to discover why we are the program with nothing to hide!',
};
